// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { useMutation } from "@apollo/client";
import { cilXCircle } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import DeleteButton from "../../../../components/UI/DeleteButton";
import { DELETE_LINKING_ID } from "../../../../graphql/queries/linked-id";

const DisplayLinkingIDS = ({ linkingIDs, onChange }) => {
  const [removeID, { loading }] = useMutation(DELETE_LINKING_ID);

  return (
    <>
      {linkingIDs.map((id) => (
        <span
          key={id.linking_id}
          className={"small rounded-5 bg-secondary-subtle p-1 ps-2 pe-2 me-2"}
        >
          {id.value}
          <DeleteButton
            message={<p>This will unlink everything linked to this ID.</p>}
            title={"Unlink ID?"}
            onDelete={() =>
              removeID({
                variables: {
                  id: id.linking_id,
                },
              })
                .then(() => {
                  onChange();
                })
                .catch((e) => {
                  console.log(e);
                })
            }
          >
            <span style={{ cursor: "pointer" }} className={"ms-1"}>
              <CIcon icon={cilXCircle} />
            </span>
          </DeleteButton>
        </span>
      ))}
    </>
  );
};

export default DisplayLinkingIDS;
